import { Message } from 'element-ui'

// 统一的消息提示封装：对「相同类型 + 相同内容」的提示在极短时间窗内去重，
// 避免出现同一条错误被弹两遍的情况（如响应拦截器统一提示 + 调用方 .catch 各自提示）。
// 组件里的 this.$message 与 utils/http.js 拦截器都走这里，共享同一份去重缓存。
const DEDUPE_MS = 1000
const lastShown = new Map()

function textOf(options) {
  if (options == null) return ''
  return typeof options === 'string' ? options : (options.message || '')
}

function shouldShow(options, type) {
  const key = (type || (options && options.type) || '') + '|' + textOf(options)
  const now = Date.now()
  const prev = lastShown.get(key)
  if (prev && (now - prev) < DEDUPE_MS) return false
  lastShown.set(key, now)
  return true
}

function message(options) {
  if (!shouldShow(options)) return
  return Message(options)
}

;['success', 'warning', 'info', 'error'].forEach(type => {
  message[type] = (options) => {
    if (!shouldShow(options, type)) return
    return Message[type](options)
  }
})

message.close = (...args) => Message.close(...args)
message.closeAll = () => Message.closeAll()

export default message
export { message as Message }
